const GlobalData = {
  websiteSettings: {
    UnderConstruction: "On",
  },
  company: {
    companyName: "The Winner India",
    companyTagLine: "The main aim of this scheme is to make your dreams come true",
    companyWebsite: "www.thewinnerindia.com",
    companyPhone: "+918919962255",
    companyEmail: "support@thewinnerindia.com",
    companyAddress: "Visakhapatnam, Andhra Pradesh 530017",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=918919962255",
  },
};

export { GlobalData };
